import React, { useState, useCallback } from 'react';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  placeholder: {
    id: 'liveChatInputPlaceholder',
    defaultMessage: 'Write a message...',
  },
  send: { id: 'liveChatSend', defaultMessage: 'Send' },
});

const ChatInput = ({ onSend, disabled }) => {
  const intl = useIntl();
  const [text, setText] = useState('');

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (text.trim() && !disabled) {
        onSend(text.trim());
        setText('');
      }
    },
    [text, disabled, onSend],
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        if (text.trim() && !disabled) {
          onSend(text.trim());
          setText('');
        }
      }
    },
    [text, disabled, onSend],
  );

  return (
    <form className="live-chat-input" onSubmit={handleSubmit}>
      <input
        type="text"
        className="live-chat-input-field"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={intl.formatMessage(messages.placeholder)}
        aria-label={intl.formatMessage(messages.placeholder)}
        disabled={disabled}
        maxLength={500}
      />
      <button
        type="submit"
        className="live-chat-send-btn"
        disabled={disabled || !text.trim()}
        aria-label={intl.formatMessage(messages.send)}
      >
        ›
      </button>
    </form>
  );
};

export default ChatInput;
